import clsx from 'clsx';
import React from 'react';
import useStyles from './BadgeStepStyles';
export default function BadgeStep({
  children,
  badgeContent,
  className
}) {
  const {
    badgeStep,
    badge
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: badgeStep
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(badge, className)
  }, badgeContent), children);
}
BadgeStep.defaultProps = {
  className: ''
};